import { logger } from '../logger';
import { gameUrl as gameUrlBuilder } from '../url-builders';

export const DEFAULT_GUARANTEE = 7;

const guarantees = {
  custom_single_round: 7,
  kickstarter: 7,
  transformer: 14,
};

export const guaranteeBySubtype = (subtype) =>
  guarantees[subtype] || DEFAULT_GUARANTEE;

export const isRoutinesCampaignGame = (game) =>
  !!game?.labels?.find((label) => label.name.includes('routines-'));

export const selectGameUrl = (urlOrigin, game) => {
  if (game?.id) {
    if (!game.type) {
      logger.error('selectGameUrl: missing game.type in game.', game);
      return undefined;
    }
    const gameUrl = new URL(urlOrigin);
    gameUrl.pathname = gameUrlBuilder({ gameId: game.id, product: game.type });
    return gameUrl.toString();
  }
  return undefined;
};

export const selectImageUrl = (game) =>
  game?.squareImageUrl || game?.imageUrl || game?.image?.url || '';
